import { Base } from './_base.model';

export class Checklist extends Base {
  id: number;
  text: string;
  event_card_category_id: string;
  active: boolean;
  choices: string;
  other: boolean;
  formatting: string;
  rank: number;
  url: string;
  assignee: string;
  scope: string;
  action: string;
  priority: string;
  blocker_ids: string[];
  /** Global Barkani checklist template key (`public."ChecklistGlobal".name`); links company row to the default library. */
  gchk_name?: string | null;

  deleted: boolean;
  restored?: boolean;
  /** Row checkbox on /tools/checklist; means Archive on the live list, Restore on the archive list. */
  marked?: boolean;
}

